<template>
  <div>
    <Card shadow>
      <Row :gutter="18">
        <Col span="7" style="display:none">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">代理组:</span>
            <Select
              v-model="table.params.platform"
              filterable
              placeholder="选择APP分组"
              clearable
            >
              <Option
                v-for="(item, index) in plat_list.filter(el => el.id != 29)"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              :disabled="!table.params.platform"
              filterable
              placeholder="选择APP盘口"
              :max-tag-count="3"
              clearable
            >
              <Option
                v-for="(item, index) in app_list.filter(
                  item => item.platform == table.params.platform
                )"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="13">
          <Button
            type="primary"
            @click="GetAlarm(1)"
            :disabled="!table.params.platform || !table.params.app_id"
            >查询</Button
          >
          <Button
            style="margin-left: 10px"
            :disabled="!table.params.platform || !table.params.app_id"
            type="primary"
            @click="addshow(1)"
            >新增异常数据监控</Button
          >
          <Button
            style="margin-left: 10px"
            :disabled="!table.params.platform || !table.params.app_id"
            type="primary"
            @click="addshow(0)"
            >新增后台异常登录报警</Button
          >
          <Button
            style="margin-left: 10px"
            :disabled="!table.params.platform || !table.params.app_id"
            type="primary"
            @click="GetGroupaddshow"
            >报警发送地址配置</Button
          >
        </Col>
      </Row>
    </Card>
    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 10px"
      :max-height="450"
    ></Table>
    <Page
      v-show="table.data.length"
      style="margin-top: 10px"
      :current="table.params.page"
      :total="table.total"
      :page-size-opts="table.pageSizes"
      :page-size="table.params.limit"
      show-sizer
      @on-page-size-change="limitchange"
      @on-change="pagechange"
    ></Page>
    <!-- 修改警报配置 -->
    <Modal v-model="setAlarm.show" width="700">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>{{ setAlarm.titlename }}</span>
      </p>
      <div style="margin: 0px auto; width: 550px">
        <Form :model="setAlarm.params" :label-width="100">
          <Row>
            <Col span="18">
              <label class="ivu-form-item-label" style="width: 100px">
                <Tooltip max-width="200" v-if="setAlarm.typeIp == 1">
                  <Icon style="color: #f90" type="md-add-circle" />
                  <div slot="content" v-if="setAlarm.params.atype == 1">
                    <p>• 上一分钟实时在线-实时在线人数>数量阈值</p>
                    <p>
                      •（上一分钟实时在线-实时在线）/上一分钟在线>比例阈值同时触发2个阈值时发送警报"
                    </p>
                  </div>
                  <div slot="content" v-else>
                    <p>• 任一支付通道连续失败订单数>数量阈值</p>
                    <p>
                      •
                      任一支付通道最近10分钟成功率-通道上个10分钟成功率）/通道上个10分钟成功率>比例阈值
                    </p>
                    <p>同时触发2个阈值时发送警报</p>
                  </div> </Tooltip
                >警报类型：
              </label>
              <FormItem>
                <Select
                  v-model="setAlarm.params.atype"
                  placeholder="请选择"
                  clearable
                >
                  <Option
                    v-for="item in setAlarm.typeIp
                      ? setAlarm.atypeList.slice(0, 2)
                      : setAlarm.atypeList.slice(2)"
                    :value="item.value"
                    :key="item.value"
                    >{{ item.label }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="18">
              <label class="ivu-form-item-label" style="width: 100px">
                <Tooltip max-width="200" :content="setAlarm.group_idtext">
                  <Icon style="color: #f90" type="md-add-circle" /> </Tooltip
                >警报地址：
              </label>
              <FormItem>
                <Select v-model="setAlarm.params.group_id" filterable multiple>
                  <Option
                    v-for="item in setAlarm.group_idlist"
                    :value="item.value"
                    :key="item.value"
                    >{{ item.label }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="18" v-if="setAlarm.typeIp == 1">
              <label class="ivu-form-item-label" style="width: 100px">
                <Tooltip max-width="200" :content="setAlarm.targettext">
                  <Icon style="color: #f90" type="md-add-circle" /> </Tooltip
                >警报阈值：
              </label>
              <FormItem>
                <InputNumber
                  v-model="setAlarm.params.target"
                  placeholder="请输入数量阈值"
                  style="width: 125px"
                  :min="0"
                ></InputNumber
                >&nbsp;&nbsp;&nbsp;&nbsp;
                <InputNumber
                  v-model="setAlarm.params.threshold"
                  placeholder="请输入比例阈值"
                  style="width: 125px"
                  :min="0"
                ></InputNumber
                >&nbsp;%
              </FormItem>
            </Col>
            <Col span="18" v-if="setAlarm.typeIp == 0">
              <FormItem label="警报平台：">
                <Select
                  v-model="setAlarm.params.target"
                  placeholder="请选择"
                  clearable
                >
                  <Option
                    v-for="(item, index) in setAlarm.targetList"
                    :value="index + 1"
                    :key="index + 1"
                    >{{ item }}</Option
                  >
                </Select>
              </FormItem>
            </Col>
            <Col span="18">
              <FormItem label="备注信息：">
                <Input
                  v-model="setAlarm.params.desc"
                  placeholder="请输入备注信息"
                />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="warning" @click="setAlarm.show = false">取消</Button>
        <Button type="success" @click="UpdateAlarm">确定</Button>
      </div>
    </Modal>
    <!--请求报警群组配置列表-->
    <Modal v-model="address.show" width="800">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>报警发送地址配置</span>
      </p>
      <Button style="margin-bottom: 10px" type="primary" @click="addGroup"
        >新增报警地址</Button
      >
      <div>
        <Table border :columns="address.column" :data="address.data"></Table>
      </div>
    </Modal>
    <!-- 发送地址配置 -->
    <Modal v-model="address.setshow" width="500">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>警报地址配置</span>
      </p>
      <div style="margin: 0px auto; width: 400px">
        <Form :model="address" :label-width="100">
          <FormItem label="报警地址名称">
            <Input
              v-model="address.group_name"
              placeholder="请输入Telegram群名称"
              style="width: 200px"
            />
          </FormItem>
          <FormItem label="群ID">
            <Input
              v-model="address.group_id"
              placeholder="请输入Telegram群ID"
              style="width: 200px"
            />
            <span style="color: red; margin-left: 10px">群ID为数字</span>
          </FormItem>
        </Form>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="warning" @click="address.setshow = false">取消</Button>
        <Button type="primary" @click="UpdateGroup">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { TransTopReq } from '@/api/admin/risk'
export default {
  name: 'PlatWarn',
  data() {
    return {
      table: {
        params: { platform: 0, app_id: 0, limit: 10, page: 1 },
        pageSizes: [10, 20, 30, 40],
        total: 0,
        data: [],
        columns: [
          { type: 'index', title: '序号', width: 50, align: 'center' },
          { title: '编号', key: 'id', align: 'center' },
          {
            key: 'atype',
            align: 'center',
            render: (h, params) => h('span', this.atypename(params.row.atype)),
            renderHeader: h =>
              this.renderHeader(
                h,
                '警报数据类型',
                '显示对应的警报信息监控数据的类型；'
              )
          },
          {
            key: 'target',
            align: 'center',
            width: 150,
            render: (h, params) => {
              let str
              if (params.row.atype == 3) {
                str = params.row.target == 2 ? '银商后台' : '运营后台'
              } else {
                str = `${params.row.target}%`
              }
              return h('span', str)
            },
            renderHeader: h =>
              this.renderHeader(
                h,
                '数量阈值/报警平台',
                '当警报类型为【玩家子游戏数据】或【子游戏盈亏数据】时，显示对应的数量阈值'
              )
          },
          {
            key: 'threshold',
            align: 'center',
            width: 150,
            render: (h, params) => {
              let str
              if (params.row.atype == 3) {
                str = params.row.threshold == 2 ? '银商后台' : '运营后台'
              } else {
                str = `${params.row.threshold}%`
              }
              return h('span', str)
            },
            renderHeader: h =>
              this.renderHeader(
                h,
                '比例阈值/代理平台',
                '显示对应警报信息报警的比例阈值'
              )
          },
          {
            key: 'status',
            align: 'center',
            render: (h, params) => {
              let str = params.row.status ? '开启' : '关闭'
              return h(
                'span',
                {
                  style: {
                    color: params.row.status ? '#32CD32' : 'red'
                  }
                },
                str
              )
            },
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '警报状态',
                '显示对应警报信息当前状态；是否可用'
              )
          },
          {
            key: 'group_name',
            align: 'center',
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '警报地址',
                '显示当触发报警机制时，消息下发的地址'
              )
          },
          {
            key: 'update_time',
            align: 'center',
            renderHeader: (h, params) =>
              this.renderHeader(
                h,
                '更新时间',
                '显示创建或最后一次修改警报信息的时间；'
              )
          },
          {
            key: 'desc',
            align: 'center',
            renderHeader: (h, params) =>
              this.renderHeader(h, '备注', '显示对应警报信息设置的备注')
          },
          {
            title: '管理',
            key: 'id',
            align: 'center',
            minWidth: 100,
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'primary' },
                    style: { margin: '2px', padding: '3px 8px' },
                    on: {
                      click: () => {
                        this.setAlarm.params.id = params.row.id
                        this.setAlarm.params.atype = params.row.atype
                        if (this.setAlarm.params.atype == 3) {
                          this.setAlarm.typeIp = 0
                        } else {
                          this.setAlarm.typeIp = 1
                        }
                        this.setAlarm.titlename =
                          '修改' + this.atypename(params.row.atype)
                        this.setAlarm.params.target = params.row.target
                        this.setAlarm.params.threshold = params.row.threshold
                        this.setAlarm.params.status = params.row.status
                        this.setAlarm.params.group_id = params.row.group_id
                        this.setAlarm.params.desc = params.row.desc
                        this.setAlarm.show = true
                      }
                    }
                  },
                  '修改'
                ),
                h(
                  'Button',
                  {
                    props: { type: params.row.status ? 'warning' : 'success' },
                    style: { margin: '2px', padding: '3px 8px' },
                    on: {
                      click: () => {
                        let status = params.row.status ? 0 : 1
                        this.Updatestatus(status, params.row.id)
                      }
                    }
                  },
                  params.row.status ? '禁用' : '启用'
                ),
                h(
                  'Button',
                  {
                    props: { type: 'error' },
                    style: { margin: '2px', padding: '3px 8px' },
                    on: {
                      click: () => {
                        this.removetype(params.row.id)
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ]
      },

      //报警配置
      setAlarm: {
        show: false,
        titlename: '',
        params: {
          id: 0, // id == -1   新增一条
          atype: 0, //报警数据类型 1玩家转出 2玩家转入 3玩家盈亏 4平台转出 5平台转入 6平台盈亏
          target: 0, //配玩家ID，则可以针对该玩家，不配，表示全部玩家，配置游戏ID，则可以针对某个子游戏，不配则全部子游戏
          threshold: 0, //阈值
          status: 1, //状态 0 关闭  1 开启
          group_id: [], //警报地址
          desc: ''
        },
        typeIp: 1,
        address: '',
        targetList: ['运营后台', '银商后台'],
        group_idtext: '选择警报发送地址，可以多选',
        targettext:
          '必须同时配置数量阈值与比例阈值，监控数据同时触发2个阈值时发送警报',
        group_idlist: [],
        atypeList: []
      },
      //报警地址
      address: {
        show: false,
        data: [],
        column: [
          {
            key: 'group_name',
            align: 'center',
            renderHeader: (h, params) => {
              return h(
                'Tooltip',
                {
                  props: {
                    placement: 'top',
                    theme: 'light',
                    transfer: true
                  }
                },
                [
                  '报警地址名称',
                  h(
                    'span',
                    {
                      slot: 'content',
                      style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                    },
                    '显示配置的警报地址所代表的名称信息'
                  )
                ]
              )
            }
          },
          {
            key: 'group_id',
            align: 'center',
            renderHeader: (h, params) => {
              return h(
                'Tooltip',
                {
                  props: {
                    placement: 'top',
                    theme: 'light',
                    transfer: true
                  }
                },
                [
                  'Telegram群ID',
                  h(
                    'span',
                    {
                      slot: 'content',
                      style: { whiteSpace: 'normal', wordBreak: 'break-all' }
                    },
                    '显示地址信息对应的群ID'
                  )
                ]
              )
            }
          },
          {
            title: '管理',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'primary' },
                    style: { margin: '2px' },
                    on: {
                      click: () => {
                        this.address.id = params.row.id
                        this.address.group_name = params.row.group_name //群组名称
                        this.address.group_id = params.row.group_id
                        this.address.setshow = true
                      }
                    }
                  },
                  '修改'
                ),
                h(
                  'Button',
                  {
                    props: { type: 'warning' },
                    style: { margin: '2px' },
                    on: {
                      click: () => {
                        this.address.id = params.row.id
                        this.removetypeGroup()
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ],
        setshow: false,
        id: -1,
        group_name: '', //群组名称
        app_key: '', //APPKEY
        group_id: '' //群组
      }
    }
  },
  methods: {
    atypename(num) {
      let arr = ['实时在线监控', '支付通道监控', '异常登录监控']
      return arr[num - 1]
    },
    returnParam(func, _param) {
      return {
        mod: 'root',
        platid: this.table.params.platform,
        app_id: this.table.params.app_id,
        param: {
          _mod: 'manager',
          _func: func,
          _param: { ..._param }
        }
      }
    },
    //获取报警列表
    GetAlarm(num) {
      if (num) {
        this.table.params.page = 1
      }
      TransTopReq(this.returnParam('GetAlarmConfig', this.table.params)).then(
        res => {
          debugger
          this.table.data = res['_param'].data || []
          this.table.total = res['_param'].total
          this.setAlarm.atypeList = []
          this.setAlarm.group_idlist = []
          TransTopReq(
            this.returnParam('GetAlarmType', {
              app_id: this.table.params.app_id
            })
          ).then(res => {
            let obj = res['_param'].alarm_data
            for (let key in obj) {
              let row = {}
              row['value'] = Number(key)
              row['label'] = obj[key]
              this.setAlarm.atypeList.push(row)
            }
            let group_obj = res['_param'].group_data
            for (let key in group_obj) {
              let row = {}
              row['value'] = Number(key)
              row['label'] = group_obj[key]
              this.setAlarm.group_idlist.push(row)
            }
          })
        }
      )
    },
    limitchange(limit) {
      this.table.params.limit = limit
      this.table.params.page = 1
      this.GetAlarm()
    },
    pagechange(page) {
      this.table.params.page = page
      this.GetAlarm()
    },
    //修改报警状态
    Updatestatus(status, id) {
      let param = {
        app_id: this.table.params.app_id,
        id: id, //配置ID
        status: status
      }
      TransTopReq(this.returnParam('UpdateAlarmStatus', param)).then(res => {
        this.$Message.success('修改成功')
        this.GetAlarm()
      })
    },
    //删除
    removetype(id) {
      this.$Modal.confirm({
        title: '删除信息',
        content: '是否确认删除此警报信息',
        onOk: () => {
          this.Updatestatus(-1, id)
        }
      })
    },
    addshow(type) {
      this.setAlarm.titlename = type
        ? '新增异常数据监控'
        : '新增后台异常登录报警'
      this.setAlarm.show = true
      this.setAlarm.typeIp = type
      this.setAlarm.params = {
        id: -1, // id == -1   新增一条
        atype: 0, //报警数据类型 1玩家转出 2玩家转入 3玩家盈亏 4平台转出 5平台转入 6平台盈亏
        target: 0, //配玩家ID，则可以针对该玩家，不配，表示全部玩家，配置游戏ID，则可以针对某个子游戏，不配则全部子游戏
        threshold: 0, //阈值
        status: 1, //状态 0 关闭  1 开启
        group_id: [], //警报地址
        desc: ''
      }
    },
    ///新增或者更新一条报警配置
    UpdateAlarm() {
      if (!this.setAlarm.params.atype)
        return this.$Message.error('请选择警报类型')
      if (this.setAlarm.params.group_id.length == 0)
        return this.$Message.error('警报地址')
      let param = {
        app_id: this.table.params.app_id,
        ...this.setAlarm.params
        // id: this.setAlarm.id,             // id == -1   新增一条
        // atype: this.setAlarm.atype,          //报警数据类型 1玩家转出 2玩家转入 3玩家盈亏 4平台转出 5平台转入 6平台盈亏
        // target: Number(this.setAlarm.target),            //配玩家ID，则可以针对该玩家，不配，表示全部玩家，配置游戏ID，则可以针对某个子游戏，不配则全部子游戏
        // threshold: Number(this.setAlarm.threshold),            //阈值
        // status: this.setAlarm.status,            //状态 0 关闭  1 开启
        // group_id: this.setAlarm.group_id,         //警报地址
        // desc: this.setAlarm.desc,              //备注
      }
      TransTopReq(this.returnParam('UpdateAlarmConfig', param)).then(res => {
        if (this.setAlarm.params.id < 0) {
          this.$Message.success('添加成功')
        } else {
          this.$Message.success('修改成功')
        }
        this.setAlarm.show = false
        this.GetAlarm()
      })
    },

    GetGroupaddshow() {
      this.address.show = true
      this.GetGroup()
    },
    //请求报警群组配置列表
    GetGroup() {
      TransTopReq(
        this.returnParam('GetAlarmGroup', {
          app_id: this.table.params.app_id
        })
      ).then(res => {
        this.address.data = res['_param'].data || []
      })
    },
    //新增
    addGroup() {
      this.address.setshow = true
      this.address.group_name = '' //群组名称
      this.address.group_id = ''
      this.address.id = -1
    },
    //删除
    DelGroup() {
      let param = {
        app_id: this.table.params.app_id,
        id: Number(this.address.id)
      }
      TransTopReq(this.returnParam('DelAlarmGroup', param)).then(res => {
        this.$Message.success('删除成功')
        this.GetGroup()
      })
    },
    //新增或者更新一条报警群组配置
    UpdateGroup() {
      if (!this.address.group_name)
        return this.$Message.error('请输入报警地址名称')
      if (!this.address.group_id && typeof this.address.group_id != 'number')
        return this.$Message.error('请输入正确的群ID')
      let param = {
        app_id: this.table.params.app_id,
        id: Number(this.address.id),
        group_name: this.address.group_name, //群组名称
        group_id: Number(this.address.group_id) //群组ID
      }
      TransTopReq(this.returnParam('UpdateAlarmGroup', param)).then(res => {
        this.$Message.success('修改配置成功')
        this.address.setshow = false
        this.GetGroup()
      })
    },
    //删除报警群组配置
    removetypeGroup() {
      this.$Modal.confirm({
        title: '删除信息',
        content: '是否确认删除此警报信息配置',
        onOk: () => {
          this.DelGroup()
        }
      })
    },
    initFunc() {
      this.table.params.platform = this.plat_list.filter(el => el.id != 29)[
        this.$initIndex
      ].id
      this.table.params.app_id = this.app_list.filter(
        item => item.platform == this.table.params.platform
      )[0]['appid']
      this.GetAlarm()
    }
  },

  created() {
    this.initFunc()
    //获取报警数据类型
  }
}
</script>
<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}
</style>
